export const aboutData = [
    {
      category: "Education",
      details: [
        { type: "education", name: "Graduation", institution: "Vaagdevi Institute Of Technology & Science", duration: "2021 - 2025" },
        { type: "education", name: "Intermediate", institution: "Vivekananda Junior College", duration: "2019 - 2021" },
        { type: "education", name: "High School", institution: "P.R. Govt High School", duration: "2016 - 2019" }
      ]
    },
    {
      category: "Certifications",
      details: [
        { type: "certification", name: "Python Certificate", institution: "Pantech E-Learning", duration: "27 - 11 - 2023 to 27 - 12 - 2023" },
        { type: "certification", name: "Web Development Course 2.0", institution: "Infosys Springboard", duration: "15 - 09 - 2023 to 15 - 10 - 2023" },
        { type: "certification", name: "Web Development Internship Completion Certificate", institution: "Bharat Intern", duration: "10 - 11 - 2023 to 10 - 12 - 2023" },
        { type: "certification", name: "Web Development Internship Completion Certificate", institution: "Innovixion", duration: "01 - 03 - 2024 to 01 - 04 - 2024" }
      ]
    }
  ];
  